import { Builder } from '@builder.io/sdk';
import dynamic from 'next/dynamic';

const PageAlert = dynamic(() => import('./PageAlert').then((m) => ({ default: m.PageAlert })));

const PageAlertConfig = {
  name: 'PageAlert',
  inputs: [
    {
      name: 'variant',
      type: 'enum',
      defaultValue: 'brand',
      enum: [
        { label: 'Brand (Orange)', value: 'brand' },
        { label: 'Error (Red)', value: 'error' },
        { label: 'Success (Green)', value: 'success' },
        { label: 'Info (Blue)', value: 'info' },
      ],
      helperText: 'The color variant of the alert',
    },
    {
      name: 'headline',
      type: 'string',
      defaultValue: 'Important notice',
      helperText: 'Bold headline text for the alert',
    },
    {
      name: 'body',
      type: 'string',
      helperText: 'Optional body text below the headline',
    },
  ],
};

Builder.registerComponent(PageAlert, PageAlertConfig);
